@use '../../../../styles/Constants.scss' as Constants;
@use '../../../../styles/Colors.scss' as Colors;

.name-cell {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-xs;
	align-items: flex-start;
	width: 100%;

	:global(.tooltip__trigger-wrapper) {
		flex: 0 0 auto;
		overflow: visible;
	}
}

.warning-icon {
	color: red;
}